import React, { FC, useRef } from 'react';
import { useClickedOutside } from 'src/hooks/use-clicked-outside';
import styled, { css } from 'styled-components';
import { Black, White } from '../../../styles/colours';

interface IOverlay {
  open: boolean;
  onClickOutside: () => void;
}

const StyledOverlay = styled.div<{
  open: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  z-index: 2;
  background: ${White};
  color: ${Black};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);

  width: 81rem;
  transform: translateX(-82rem);
  transition: all 200ms ease-in-out;

  padding: 3rem 6rem;
  overflow-y: auto;

  ${props =>
    props.open &&
    css`
      transform: translateX(0rem);
    `}
`;
export const Overlay: FC<IOverlay> = ({
  open,
  children,
  onClickOutside,
  ...rest
}) => {
  const slideOutRef = useRef<any>();
  useClickedOutside(slideOutRef, onClickOutside);

  return (
    <StyledOverlay ref={slideOutRef} open={open} data-type="overlay" {...rest}>
      {children}
    </StyledOverlay>
  );
};
